import { makeStyles } from "@material-ui/core/styles"

const useStyles = makeStyles(theme => ({
  root: {
    position: "relative",
    flexGrow: 1,
    marginTop: 76,

    [theme.breakpoints.up("lg")]: {
      borderBottom: "1px solid #F4F6F8",
    },
  },
  menuWrapper: {
    top: `calc(76px + 44px) !important`,
    width: "100%",
    maxWidth: 212,
    boxShadow:
      "0px 3px 5px rgba(33, 43, 54, 0.2), 0px 0px 1px rgba(33, 43, 54, 0.31)",
    borderRadius: theme.spacing(0.5),
  },
  menuButton: {
    "&:hover": {
      backgroundColor: "#FFF",
    },

    "& > .MuiTouchRipple-root": {
      opacity: 0,
    },
  },
  menuItem: {
    color: "#454F5B",
    ...theme.typography.caption,

    "&:hover": {
      backgroundColor: "#FFFAE6",
      color: "#FFA800",
    },
  },
  inputWrapper: {
    display: "block",
    maxWidth: 375,
    padding: theme.spacing(2),
    margin: "0 auto",
  },
}))

export default useStyles
